export default __webpack_public_path__ + "static/media/2pac-album.057fa629.png";